export const ADD = 'entities/form/ADD';
export const ADD_MULTIPLE = 'entities/form/ADD_MULTIPLE';
export const UPDATE = 'entities/form/UPDATE';
export const REMOVE = 'entities/form/REMOVE';
